import angular from 'angular';

class KubernetesConfigService {
  /* @ngInject */
  constructor(KubernetesConfig, FileSaver, SettingsService) {
    this.KubernetesConfig = KubernetesConfig;
    this.FileSaver = FileSaver;
    this.SettingsService = SettingsService;
  }

  async downloadKubeconfigFile(environmentIDs) {
    const response = await this.KubernetesConfig.get(environmentIDs);
    const headers = response.headers();
    const contentDispositionHeader = headers['content-disposition'];
    const filename = contentDispositionHeader.replace('attachment;', '').trim();
    return this.FileSaver.saveAs(response.data, filename);
  }

  async expiryMessage() {
    const settings = await this.SettingsService.publicSettings();
    const expiryDays = settings.KubeconfigExpiry;
    const prefix = 'Срок действия файла kubeconfig ';
    switch (expiryDays) {
      case '0':
        return prefix + 'не ограничен.';
      case '24h':
        return prefix + '— 1 день.';
      case '168h':
        return prefix + '— 7 дней.';
      case '720h':
        return prefix + '— 30 дней.';
      case '8640h':
        return prefix + '— 1 год.';
    }
    return '';
  }
}

export default KubernetesConfigService;
angular.module('shbdeployer.kubernetes').service('KubernetesConfigService', KubernetesConfigService);
